<template>
    <div id="app">
        <router-view></router-view>
        <modal
            class="c-m-modal--xsmall"
            :hideCloseButton="true"
            v-if="showNotifyQueue"
            @close="hideNotifyQueue"
        >
            <div class="c-m-modal--notify-queue">
                <h2>Företaget valt till förfrågan!</h2>
                <p>
                    Genom att välja ut (upp till sex) företag kan du skapa en
                    förfrågan som skickas ut direkt till dessa. Utvalda företag
                    hittas under "Valda" i huvudmenyn, varifrån du sedan kan
                    initiera din förfrågan.
                </p>
                <atom-button
                    :label="'Jag förstår'"
                    @buttonClicked="hideNotifyQueue"
                ></atom-button>
            </div>
        </modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    FETCH_FROM_LOCAL_STORAGE,
    GET_COMPANIES,
    DISMISS_FIRST_COMPANY_SELECTION_NOTICE,
    IS_FIRST_COMPANY_SELECTION
} from "./store/store-models/queued-companies-model";
import { FETCH_META_DATA } from "./store/store-models/meta-model";

import Modal from "./views/components/molecules/MoleculeModal.vue";
import AtomButton from "./views/components/atoms/AtomButton.vue";

export default {
    data() {
        return {
            showModal: false
        };
    },
    async asyncData({ store, route }) {
        return store.dispatch(FETCH_META_DATA);
    },
    components: {
        Modal,
        AtomButton
    },
    name: "app",
    computed: {
        ...mapGetters({
            queuedCompanies: GET_COMPANIES,
            showNotifyQueue: IS_FIRST_COMPANY_SELECTION
        })
    },
    methods: {
        ...mapActions({
            fetchLocalStorage: FETCH_FROM_LOCAL_STORAGE
        }),
        hideNotifyQueue: function() {
            this.$store.dispatch(DISMISS_FIRST_COMPANY_SELECTION_NOTICE);
        }
    },
    created() {
        this.fetchLocalStorage();
    },
    metaData() {
        return {
            title: this.$route.name,
            titleTemplate: "%s | BraByggare",
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content:
                        "Hitta kvalitetssäkrade hantverkare enkelt och tryggt. Gratis förfrågan och upp till 6 snabba svar från bra hantverkare nära dig."
                }
            ]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/App.vue